<form [formGroup]="form" autocomplete="off" class="form-horizontal">
  <div id="eroeffnungsbilanzwirtschaftsjahr">
    <div class="mb-5x">

      <div *ngIf="isKapGAus" class="mb-3x mt-1x">
        <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.WIRTSCHAFTJAHR_INFO' | translate"
                        type="info">
        </common-ui-card>
      </div>

      <div class="form-row">
        <label class="col-sm-8 col-form-label"
               for="wirtschaftsJahr">{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.LIEGT_ABW_WJ_VOR' | translate }}
        </label>
        <div class="col-sm-4">
          <select class="form-control" datevMessagePath="wirtschaftsJahr{{objectId}}"
                  formControlName="wirtschaftsJahr" id="wirtschaftsJahr" (change)="onWirtschaftsJahrChanged()"
                  utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage>
            <option [ngValue]="null"
                    selected>{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.NULL' | translate }}</option>
            <option [ngValue]="true"
                    selected>{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.TRUE_VALUE' | translate }}</option>
            <option [ngValue]="false"
                    selected>{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.FALSE_VALUE' | translate }}</option>
          </select>
        </div>
      </div>

      <div *ngIf="showVomBisAngaben()">
        <div class="form-row">
          <label class="col-sm-8 col-form-label" for="abweichendesWirtschaftsjahrVon">
            {{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.ABWEICHENDES_WJ_VOM' | translate }}
          </label>
          <div class="col-sm-4">
            <date-picker
                    id="abweichendesWirtschaftsjahrVon"
                    messagePath="abweichendesWirtschaftsjahrVon"
                    formControlName="abweichendesWirtschaftsjahrVon"
                    [isRequired]=true>
            </date-picker>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
